import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaPinterestP, FaLinkedin, FaInstagram, FaVimeoV, FaDribbble, FaBehance, FaEnvelopeOpen, FaTiktok, FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import ServiceData from "../../data/service/ServiceMain.json";
import { slugify } from '../../utils';
import { useLanguage } from '../../context/LanguageContext';
import { useTheme } from '../../context/ThemeContext';
import { Features } from '../../assets/features/Features';

const getServiceData = ServiceData;

const FooterOne = ({parentClass}) => {
    const { language } = useLanguage();
    const { theme } = useTheme();
    
    // Determine footer logo based on theme
    const footerLogo = theme === 'dark' ? "/images/1.png" : "/images/3.png";
    
    // Helper function to capitalize only first letter (for footer menu)
    const capitalizeFirst = (text) => {
        if (!text) return text;
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    };
    
    return (
        <footer className={`footer-area ${parentClass}`}>
            <div className="container">
                <div className="footer-top">
                </div>
                <div className="footer-main">
                    <div className="row">
                        <div className="col-xl-3 col-lg-3 col-md-6">
                            <div className="footer-widget">
                                <div className="footer-newsletter">
                                    <div style={{marginBottom: '20px'}}>
                                        <Link to="/">
                                            <img src={process.env.PUBLIC_URL + footerLogo} alt="Fiel Carga Logo" style={{maxWidth: '200px', height: 'auto'}} />
                                        </Link>
                                    </div>
                                    <p>{Features.FOOTER.COMMITMENT[language]}</p>
                                    <p>{Features.FOOTER.LICENSE[language]}</p>
                                    <div className="footer-social-link" style={{marginBottom: '20px'}}>
                                        <ul className="list-unstyled">
                                            <li><a href="https://www.facebook.com/profile.php?id=100063738572421" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a></li>
                                        </ul>
                                        </div>
                                    <Link to="/contactos" className="axil-btn btn-fill-primary">{Features.FOOTER.REQUEST_QUOTE[language]}</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-12 footer-services-menu-wrapper">
                            <div className="row">
                                <div className="col-6 col-md-6 footer-services-col">
                                    <div className="footer-widget" style={{paddingLeft: '35px'}}>
                                        <h6 className="widget-title">{Features.FOOTER.SERVICES_TITLE[language]}</h6>
                                        <div className="footer-menu-link">
                                            <ul className="list-unstyled">
                                        <li><Link to="/contactos">{Features.FOOTER.SERVICE_TRANSPORTES[language]}</Link></li>
                                        <li><Link to="/contactos">{Features.FOOTER.SERVICE_MUDANCAS_PARTICULARES[language]}</Link></li>
                                        <li><Link to="/contactos">{Features.FOOTER.SERVICE_MUDANCAS_EMPRESARIAIS[language]}</Link></li>
                                        <li><Link to="/contactos">{Features.FOOTER.SERVICE_TRANSPORTES_NACIONAIS[language]}</Link></li>
                                        <li><Link to="/contactos">{Features.FOOTER.SERVICE_TRANSPORTES_INTERNACIONAIS[language]}</Link></li>
                                        <li><Link to="/contactos">{Features.FOOTER.SERVICE_ORCAMENTO[language]}</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6 col-md-6 footer-menu-col">
                                    <div className="footer-widget">
                                        <h6 className="widget-title">{Features.FOOTER.MENU_TITLE[language]}</h6>
                                        <div className="footer-menu-link">
                                            <ul className="list-unstyled">
                                                <li><Link to="/">{capitalizeFirst(Features.NAV.HOME[language])}</Link></li>
                                                <li><Link to="/sobre-nos">{capitalizeFirst(Features.NAV.ABOUT[language])}</Link></li>
                                                <li><Link to="/dicas">{capitalizeFirst(Features.NAV.TIPS[language])}</Link></li>
                                                <li><Link to="/servicos">{capitalizeFirst(Features.NAV.SERVICES[language])}</Link></li>
                                                <li><Link to="/contactos">{capitalizeFirst(Features.NAV.CONTACT[language])}</Link></li>
                                                <li><Link to="/termos-de-uso">{Features.FORM.TERMS_CONDITIONS[language]}</Link></li>
                                                <li><Link to="/politica-de-privacidade">{Features.FORM.PRIVACY_POLICY[language]}</Link></li>
                                                <li><a href="#cookie-settings" onClick={(e) => { e.preventDefault(); window.dispatchEvent(new Event('openCookieSettings')); }}>{language === 'en' ? 'Cookie settings' : 'Definições de cookies'}</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-5 col-lg-5 col-md-6" style={{paddingLeft: '60px'}}>
                                    <div className="footer-widget">
                                    <h6 style={{
                                        fontSize: '16px', 
                                        fontWeight: '600', 
                                        marginBottom: '20px', 
                                        color: theme === 'dark' ? '#ffffff' : 'var(--color-dark)'
                                    }}>{Features.FOOTER.CONTACTS_TITLE[language]}</h6>
                                        <div className="footer-menu-link">
                                            <ul className="list-unstyled">
                                        <li><strong>{Features.COMMON.COMPANY_NAME[language]}</strong></li>
                                        <li style={{display: 'flex', alignItems: 'flex-start', marginBottom: '10px'}}>
                                            <FaMapMarkerAlt style={{marginRight: '10px', marginTop: '4px', flexShrink: 0}} />
                                            <span>{Features.COMMON.ADDRESS[language]}<br />{Features.COMMON.POSTAL_CODE[language]}</span>
                                        </li>
                                        <li style={{display: 'flex', alignItems: 'flex-start', marginBottom: '10px'}}>
                                            <FaPhone style={{marginRight: '10px', marginTop: '4px', flexShrink: 0}} />
                                            <span>
                                                <a href="tel:+351914440333">(+351) 914 440 333</a>
                                                <span style={{display: 'block', fontSize: '12px', opacity: 0.8}}>{Features.REGISTRATION.TOOLTIP[language]}</span>
                                            </span>
                                        </li>
                                        <li style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                                            <FaEnvelope style={{marginRight: '10px', flexShrink: 0}} />
                                            <a href="mailto:geral@fielcarga.pt">geral@fielcarga.pt</a>
                                        </li>
                                        <li style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                                            <FaClock style={{marginRight: '10px', flexShrink: 0}} />
                                            <span>{Features.FOOTER.HOURS[language]}</span>
                                        </li>
                                            </ul>
                                        </div>
                                <div style={{marginTop: '20px'}}>
                                    <a href="https://www.livroreclamacoes.pt" target="_blank" rel="noopener noreferrer">
                                        <img src={process.env.PUBLIC_URL + "/images/livro_relamacoes.png"} alt="Livro de Reclamações" style={{maxWidth: '150px', height: 'auto'}} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom"> 
                    <div className="row">
                        <div className="col-md-12">
                            <div className="footer-copyright text-center">
                                <span style={{display: 'block', fontSize: '12px', opacity: 0.8, marginBottom: '8px'}}>
                                    {language === 'pt'
                                        ? 'Algumas imagens deste website foram criadas ou editadas com recurso a inteligência artificial, para fins ilustrativos.'
                                        : 'Some images on this website were created or edited using artificial intelligence, for illustrative purposes.'}
                                </span>
                                <span className="copyright-text">
                                    {language === 'pt' ? 'Desenvolvido por' : 'Developed by'}{' '}
                                    <a href="https://myouweb.com" target="_blank" rel="noopener noreferrer" style={{display: 'inline-block', verticalAlign: 'top', margin: '0 5px', marginTop: '3px'}}>
                                        <img src={process.env.PUBLIC_URL + "/images/myouweb.webp"} alt="MYOUWEB" style={{height: '18px', width: 'auto', verticalAlign: 'top'}} />
                                    </a>
                                    {' '}| 2026
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>{`
                @media (min-width: 992px) {
                    .footer-services-menu-wrapper {
                        padding-left: 80px;
                    }
                    .footer-services-col {
                        padding-left: 0px;
                        padding-right: 40px;
                    }
                    .footer-services-col .footer-widget {
                        padding-left: 40px;
                    }
                    .footer-menu-col {
                        padding-left: 0;
                    }
                }
                @media (max-width: 991px) {
                    .footer-services-menu-wrapper {
                        padding-left: 0 !important;
                        margin-top: 30px;
                    }
                    .footer-services-col,
                    .footer-menu-col {
                        padding-left: 15px;
                        padding-right: 15px;
                        text-align: center;
                    }
                    .footer-services-col .footer-widget,
                    .footer-menu-col .footer-widget {
                        text-align: center;
                    }
                    .footer-services-col .widget-title,
                    .footer-menu-col .widget-title {
                        text-align: center;
                    }
                    .footer-services-col .footer-menu-link,
                    .footer-menu-col .footer-menu-link {
                        text-align: center;
                    }
                    .footer-services-col ul,
                    .footer-menu-col ul {
                        text-align: center;
                    }
                }
            `}</style>
        </footer>
    )
}

export default FooterOne;